// extracted by mini-css-extract-plugin
export var bodytext = "ParagraphContactUs-module--bodytext--4063c";
export var buttonwrapper = "ParagraphContactUs-module--buttonwrapper--50637";
export var contactinfo = "ParagraphContactUs-module--contactinfo--c00eb";
export var highlightedtextarea = "ParagraphContactUs-module--highlightedtextarea--06403";
export var lpreducedmargin = "ParagraphContactUs-module--lpreducedmargin--c442a";
export var paragraphcontactusinner = "ParagraphContactUs-module--paragraphcontactusinner--7dde5";
export var paragraphsectionreak = "ParagraphContactUs-module--paragraphsectionreak--dad40";
export var phonetext = "ParagraphContactUs-module--phonetext--1759c";
export var title = "ParagraphContactUs-module--title--19720";